import { Controller } from 'stimulus';

class MapController extends Controller {
  onBungalowClick(event) {
    this.openModal(event);
  }

  openModal({ currentTarget }) {
    const data = JSON.parse(currentTarget.dataset.bungalow);

    this.setModalData(data);

    $(this.modalTarget).modal('show');
  }

  setModalData(data) {
    this.modalTitleTarget.innerText = data.title;
    this.modalDescriptionTarget.innerHTML = data.description;
    this.modalImageTarget.src = data.image;
    this.modalUrlTarget.href = data.url;

    this.setAmountOfPersons(data.amount_of_persons);
  }

  setAmountOfPersons(persons) {
    const suffixSingular = this.modalAmountOfPersonsTarget.getAttribute('data-suffix-singular');
    const suffixPlural = this.modalAmountOfPersonsTarget.getAttribute('data-suffix-plural');

    this.modalAmountOfPersonsTarget.innerText = `${persons} ${persons === 1 ? suffixSingular : suffixPlural}`;
  }
}

MapController.targets = [
  'modal',
  'modalTitle',
  'modalImage',
  'modalDescription',
  'modalAmountOfPersons',
  'modalUrl',
];

export default MapController;
